import { call, put, takeLatest } from "redux-saga/effects";
import actions from "../actions/actionTypes";
import { apiRequestFailureAction } from "actions/requestActions";
import { showLoader, hideLoader } from "actions/soleraLoaderActions";
import { basicUsageReportData } from "actions/reportsActions";

import { fetchBasicUsageReport } from "./Api";
import fetchRequest from "./fetchSaga";

export function* basicUsageReport(data) {
  yield put(showLoader());
  let body = data.payload;
  const actualSelectedStates = body.selectedStates;
  body.selectedStates = body.selectedStates.map(a => a.value);
  if(body.type === "data"){
    let messages = { messages: [] };
    let response = yield call(fetchRequest, fetchBasicUsageReport, {body});
    if (response.status === false){
      messages.messages.push({
        key: null,
        messageText: `${response.response}`,
        type: "warning"
      });
      yield put(apiRequestFailureAction(messages));
    }
    yield put(hideLoader());
    response.filters = body;
    response.filters.selectedStates = actualSelectedStates;
    yield put(basicUsageReportData(response));
  } else if(body.type === "report"){
    let statePage = body.page;
    let stateRecords = body.records;
    body.page = body.exportPage;
    body.records = body.exportRecords;
    const response = yield call(fetchRequest, fetchBasicUsageReport, {body}, true);
    let blob = yield call(getBlob, response);
    yield call(downloadReport, blob);
    yield put(hideLoader());
    body.page = statePage;
    body.records = stateRecords;
    response.filters = body;
    response.filters.selectedStates = actualSelectedStates;
  }
}

function getBlob(response) {
  let blob = response.blob().then(data => {
    return new Blob([data], { type: "application/xlsx" });
  });
  return blob;
}

function downloadReport(blob){
  let url = window.URL.createObjectURL(blob);
  let tempLink = document.createElement('a');
  tempLink.href = url;
  tempLink.setAttribute('download', 'basic_usage_report_'+ new Date().toJSON().slice(0,10) +'.xlsx');
  tempLink.click();
}

export const reportSagas = [
  takeLatest(actions.BASIC_USAGE_REPORT, basicUsageReport)
];